import { create } from "zustand";

const useMeStore = create((set) => ({
  me: undefined,
  storeMe: (me) => set((state) => ({ ...state, me: me })),
}));

export default useMeStore;
